import { useState } from "react";
import { useMutation } from "@apollo/client";
import { CANCEL_SCHEDULED_NOTIFICATION } from "../../graphql/notificationQueries";
import { useToast } from "../Toast/toastHook";

const formatScheduled = (raw) => {
  const d = new Date(+raw);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const CancelScheduledNotificationModal = ({ notification, recipient, onClose }) => {
  const toast = useToast(4000);
  const [canceling, setCanceling] = useState(false);

  const [cancelScheduledNotification] = useMutation(CANCEL_SCHEDULED_NOTIFICATION, {
    refetchQueries: ["getSentNotifications"],
    onCompleted(result) {
      toast("success", result?.cancelScheduledNotification || "Scheduled notification canceled.");
      onClose();
    },
    onError(e) {
      toast("error", e?.message ?? "Something went wrong!");
      setCanceling(false);
    },
  });

  const handleCancel = () => {
    setCanceling(true);
    cancelScheduledNotification({ variables: { id: notification._id } });
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 relative">
        <h2 className="text-lg font-semibold text-gray-900 m-0 mb-2">
          Cancel scheduled notification?
        </h2>
        <p className="text-sm text-secondary mb-5">
          "{notification.title}" will not be sent to <b>{recipient}</b> on{" "}
          <b>{formatScheduled(notification.scheduledAt)}</b>.
        </p>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded border border-[#e3e5e9] px-4 py-2 text-sm font-semibold text-secondary"
          >
            Keep scheduled
          </button>
          <button
            type="button"
            onClick={handleCancel}
            disabled={canceling}
            className="rounded bg-red px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
          >
            {canceling ? "Canceling…" : "Cancel send"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelScheduledNotificationModal;
